/* eslint-disable */
import React, { Fragment, useRef, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CompanyLogo from "../../../../assets/images/ck_logo_new.png";
import { Button, CircularProgress } from "@material-ui/core";
import ReactToPrint from "react-to-print";
import { useParams } from "react-router-dom";
import { HttpRequest } from "../../../../utils/httpRequests";
import CustomizedSnackbar from "../../../../components/CustomizedSnackbar/CustomizedSnackbar";
import Barcode from "react-barcode";
import format from "date-fns/format";
import ControlledDialog from "../../../../components/ControlledDialog/ControlledDialog";
import { Tooltip, IconButton } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import "./MyMediaPrint.css";
import { IsEmpty } from "../../../../utils/helper";
const useStyles = makeStyles(() => ({
  page: {
    padding: 5,
    position: 'relative',
  },
  imageContent: {
    objectFit: "contain",
    maxHeight: "50px",
    maxWidth: "50px",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  topImageContainer: {
    justifyContent: "center",
    display: "flex",
  },
  userDetailsContainer: {
    fontSize: 14,
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: 10,
  },
  calDetailsContainer: {
    fontSize: 14,
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: 10,
  },
  userDetails: {
    fontSize: 14,
    width: "50%",
    textAlign: "left",
  },
  userDetailsRight: {
    fontSize: 14,
    width: "50%",
    textAlign: "right",
  },
  invoiceDetails: {
    fontSize: 14,
    width: "50%",
    textAlign: "left",
  },
  invoiceDetailsRight: {
    fontSize: 14,
    width: "50%",
    textAlign: "right",
  },
  table: {
    fontSize: 14,
    borderCollapse: "collapse",
    width: "100%",
  },
  tableContent: {
    fontSize: 14,
    border: "1px solid #000000",
    textAlign: "center",
    justifyContent: "center",
    padding: 8,
  },
  tableDescriptionContent: {
    fontSize: 14,
    border: "1px solid #000000",
    textAlign: "left",
    padding: 8,
  },
  footerContainer: {
    fontSize: 14,
    display: "flex",
    justifyContent: "center",
    float: "right",
    marginTop: 20,
  },
  loadingContainer: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  loader: {
    marginTop: "20%",
  },
  summaryContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginRight: 20,
    width: "50%",
    float: "right",
  },
  summaryContainerDisputed: {
    display: "flex",
    justifyContent: "space-between",
    marginRight: 20,
    width: "59%",
    float: "right",
  },
  summaryTitle: {
    fontSize: 14,
    width: "70%",
    display: "flex",
    justifyContent: "end",
    fontWeight: 600,
  },
  summaryValue: {
    fontSize: 14,
    width: "30%",
    display: "flex",
    justifyContent: "end",
    fontWeight: 600,
  },
  // Add this new watermark style
  paidWatermark: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%) rotate(-45deg)',
    fontSize: 80,
    fontWeight: 'bold',
    color: 'rgba(255, 0, 0, 0.1)', // Very transparent red
    zIndex: 1,
    pointerEvents: 'none', // Allows clicking through the watermark
    userSelect: 'none', // Prevents text selection
    fontFamily: 'Arial, sans-serif',
    letterSpacing: '8px',
    '@media print': {
      WebkitPrintColorAdjust: 'exact',
      colorAdjust: 'exact',
    },
  },
  contentContainer: {
    position: 'relative',
    zIndex: 2,
  },
  messageBox: {
    border: "1px solid #000",
    padding: 15,
    marginTop: 20,
    marginBottom: 20,
    backgroundColor: "#fffafa",
    fontSize: 14,
    lineHeight: 1.5,
  },
  orderRefContainer: {
    border: "1px solid #000",
    padding: 10,
    marginBottom: 20,
    fontSize: 14,
  },
}));

const DispatchSalesInvoice = (props) => {
  const classes = useStyles();
  const componentRef = useRef();

  //   let { orderId } = useParams();
  let { orderId } = props;

  const [dispatchSalesInvoiceData, setDispatchSalesInvoiceData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenSnackbar, setIsOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("");

  const [userName, setUserName] = useState("");
  const [dateTime, setDateTime] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");

  const mounted = useRef();

  useEffect(() => {
    if (!mounted.current) {
      const ckObject = localStorage.getItem("ckAdminUser") || "{}";
      const jsonCkObject = JSON.parse(ckObject) || {};
      const name = jsonCkObject.displayName || "";
      setUserName(name);
      mounted.current = true;
    } else {
      if (props.open == true) {
        getSalesOrderData(orderId);
        setDateTime(format(new Date(), "dd/mm/yyyy hh:mm a"));
      }
    }
  }, [props.open]);

  const getSalesOrderData = async (orderId) => {
    let resData = [];
    setIsLoading(true);
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C09SalesOrderViewByIdForSalesInvoice?orderId=${orderId}`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      setIsLoading(false);
      resData = res.data || [];
      if (!IsEmpty(resData)) {
        //if(resData[0].paymentMethod!="COD"){
        setPaymentMethod(resData[0].paymentMethod)
        //}
      }


    } else {
      setIsLoading(false);
      handleSnackbar(true, `${res.message}`, "error");
    }
    setDispatchSalesInvoiceData(resData);
  };

  const handleSnackbar = (isOpen, message, severity) => {
    setIsOpenSnackbar(isOpen);
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
  };



  return (
    <Fragment>
      <ControlledDialog
        hideClose
        open={props.open}
        disableBackdropClick
        handleClose={() => props.handleClose()}
        title={
          <Fragment>
            <Tooltip title="Back">
              <IconButton onClick={() => props.handleClose()}>
                <ArrowBackIcon fontSize="small" color="primary" />
              </IconButton>
            </Tooltip>
            <span
              style={{
                fontSize: 18,
                color: "#1558a2",
                fontWeight: 700,
              }}
            >{`Print Shipping Invoice`}</span>
          </Fragment>
        }
        content={

          <Fragment>
            {isLoading ? (
              <div className={classes.loadingContainer}>
                <CircularProgress className={classes.loader} color="primary" />
              </div>
            ) : dispatchSalesInvoiceData &&
              dispatchSalesInvoiceData.length > 0 ? (
              <div>
                <div ref={componentRef} className={classes.page}>

                  {/* PAID STAMP - Show when payment method is not COD */}
                  {paymentMethod != "COD" && paymentMethod != "" && (
                    <div className={classes.paidWatermark}>
                      PAID
                    </div>
                  )}

                  <div className={classes.contentContainer}>

                    <div className={classes.headerContainer}>
                      <div style={{ padding: "10px" }}>
                        <img
                          alt="ColorKahar"
                          src={CompanyLogo}
                          className={classes.imageContent}
                        />
                      </div>
                      <div className={classes.topImageContainer}>
                        <div style={{ display: "flex", alignItems: "top" }}>
                          <span
                            style={{
                              fontWeight: 700,
                              fontSize: 26,
                              marginBottom: 10,
                            }}
                          >
                            Color Kahar
                          </span>
                        </div>
                      </div>

                      <div className={classes.topImageContainer}>
                        <Barcode
                          value={orderId}
                          width={2}
                          height={50}
                          className={classes.imageContent}
                          displayValue={false}
                          fontSize={16}
                        />
                      </div>
                    </div>

                    <div className={classes.userDetailsContainer}>
                      <div className={classes.invoiceDetails}>
                        <strong>Date:</strong>{" "}
                        {dispatchSalesInvoiceData[0]["createdOnLabel"]}
                      </div>
                      <div className={classes.invoiceDetailsRight}>
                        {dispatchSalesInvoiceData[0]["isDisputedOrder"] != 1 && (<>
                          <strong>Invoice # :</strong> CK-{orderId}
                        </>)}
                      </div>
                    </div>

                    <div className={classes.userDetailsContainer}>
                      <div className={classes.userDetails}>
                        <strong>Customer: </strong>
                        {dispatchSalesInvoiceData[0]["toName"]}{" "}
                      </div>

                      <div className={classes.userDetailsRight}>
                        <strong>Contact no: </strong>
                        {dispatchSalesInvoiceData[0]["toContactNo"]}
                        <br />
                      </div>
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      {" "}
                      <strong>Address: </strong>
                      {dispatchSalesInvoiceData[0]["toAddress"]}
                      <br />
                    </div>

                    {dispatchSalesInvoiceData[0]["isDisputedOrder"] == 1 && (<>
                      <h4 style={{ marginTop: 20 }}>DISPUTE DETAILS</h4>
                      <div className={classes.orderRefContainer}>
                        <div><strong>Previous Order:</strong>CK-{dispatchSalesInvoiceData[0]["previousOrderId"]}</div>
                        <div><strong>New Order:</strong> CK-{orderId}</div>
                        <div><strong>Dispute Reason:</strong> {dispatchSalesInvoiceData[0]["disputeReason"]}</div>
                        {dispatchSalesInvoiceData[0]["disputeRemarks"] != null && <div><strong>Dispute Remarks:</strong> {dispatchSalesInvoiceData[0]["disputeRemarks"]}</div>}
                      </div>
                    </>)}


                    <h4>ORDER SUMMARY</h4>
                    <table className={classes.table}>
                      <thead>
                        <tr className="line">
                          <td className={classes.tableContent}>
                            <strong>#</strong>
                          </td>
                          <td className={classes.tableContent}>
                            <strong>Product Description</strong>
                          </td>
                          <td className={classes.tableContent}>
                            <strong>Qty</strong>
                          </td>
                          {dispatchSalesInvoiceData[0]["isDisputedOrder"] != 1 && (<>
                            <td className={classes.tableContent}>
                              <strong>Price</strong>
                            </td>
                             <td className={classes.tableContent}>
                              <strong>Discount</strong>
                            </td>
                            <td className={classes.tableContent}>
                              <strong>GST 18%</strong>
                            </td>
                            <td className={classes.tableContent}>
                              <strong>Amount</strong>
                            </td></>)}
                        </tr>
                      </thead>
                      <tbody>
                        {dispatchSalesInvoiceData[0]["salesOrderItemsList"].map(
                          (item, index) => (
                            <tr key={item}>
                              <td className={classes.tableContent}>
                                {index + 1}
                              </td>
                              <td className={classes.tableDescriptionContent}>
                                <div>
                                  <strong>{item["productUserLabel"]} </strong>
                                  {item.isBundleProduct == 1 &&
                                    item.productUserLabelsList && (
                                      <div
                                        style={{
                                          fontSize: 12,
                                        }}
                                      >
                                        {item.productUserLabelsList.map(
                                          (bundleProduct) => {
                                            return (
                                              <div key={bundleProduct}>
                                                {bundleProduct}
                                              </div>
                                            );
                                          }
                                        )}
                                      </div>
                                    )}
                                </div>
                                <br />
                                {item["salesOrderItemsAddonsList"].map(
                                  (addOn, index) => (
                                    // eslint-disable-next-line eqeqeq
                                    <div key={addOn}>
                                      {addOn["productUserLabel"]}{" "}
                                      {index ==
                                        item["salesOrderItemsAddonsList"].length - 1
                                        ? ""
                                        : ", "}{" "}
                                    </div>
                                  )
                                )}
                              </td>
                              <td className={classes.tableContent}>
                                {item["quantity"]}
                              </td>
                              {dispatchSalesInvoiceData[0]["isDisputedOrder"] != 1 && (<>
                                {/* <td className={classes.tableContent}>
                                  {item["totalPriceLabel"]}
                                </td> */}
                                 <td className={classes.tableContent}>
                                  {item["totalPriceLabel"]}
                                </td>
                               <td 
                                style={item["itemDiscount"] && item["itemDiscount"] > 0 ? {color:"red"} : {}} 
                                className={classes.tableContent}
                              >
                                {item["itemDiscount"] && item["itemDiscount"] > 0 
                                  ? `- ${item["itemDiscountLabel"]}` 
                                  : "-"
                                }
                              </td>  
                                
                                <td className={classes.tableContent}>
                                  {item["itemGstLabel"]}
                                </td>

                                <td className={classes.tableContent}>
                                  {item["itemGrossAmountLabel"]}
                                </td>
                              </>)}
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                    <br />

                    {/* If Disputed recreate order */}
                    {dispatchSalesInvoiceData[0]["isDisputedOrder"] == 1 ? (
                      <>
                        <hr style={{ borderTop: '1px solid #000', marginBottom: 20, marginTop: 20 }} />

                        {/* --- CUSTOMER MESSAGE --- */}
                        <div className={classes.messageBox}>
                          <div style={{ fontWeight: 'bold', marginBottom: 10 }}>📧 CUSTOMER MESSAGE</div>
                          <p>Dear Valued Customer,</p>
                          <p>We sincerely apologize for the inconvenience caused with your previous order (CK-{dispatchSalesInvoiceData[0]["previousOrderId"]}).</p>
                          <p><strong>Dispute Reason: {dispatchSalesInvoiceData[0]["disputeReason"]}</strong></p>
                          {dispatchSalesInvoiceData[0]["disputeRemarks"] != null && <p><strong>Dispute Remarks: {dispatchSalesInvoiceData[0]["disputeRemarks"]}</strong></p>}
                          <p>We have carefully reviewed your concern and are sending you replacement items as detailed above. Your satisfaction is our top priority, and we appreciate your patience and understanding.</p>
                          <p>If you have any questions or concerns, please don't hesitate to contact us at support@colorkahar.com.</p>
                          <p>Thank you for choosing ColorKahar!</p>
                          <br />
                          <p>- ColorKahar Team</p>
                        </div>
                      </>
                    ) : (
                      <>


                        <div className={classes.calDetailsContainer}>
                          <div>
                            <strong></strong>
                          </div>
                          <div>
                            <strong></strong>
                          </div>
                          <div className={classes.summaryContainer}>
                            <div className={classes.summaryTitle}>Sub Total (Price): </div>
                            <div className={classes.summaryValue}>
                              {dispatchSalesInvoiceData[0]["totalGrossAmountLabel"]}{" "}
                              Rs
                            </div>
                          </div>
                        </div>

                        <div className={classes.calDetailsContainer}>
                          <div>
                            <strong></strong>
                          </div>
                          <div>
                            <strong></strong>
                          </div>
                          <div className={classes.summaryContainer}>
                            {/* <div
                              className={classes.summaryTitle}
                              style={{
                                fontSize: "12px",
                              }}
                            >
                             Total Discount:{" "}
                            </div>
                            <div
                              className={classes.summaryValue}
                              style={{
                                fontSize: "12px",
                              }}
                            >
                              {`${(dispatchSalesInvoiceData[0][
                                "totalDiscountedAmountLabel"
                              ] || 0) > 0
                                ? " - "
                                : ""
                                }
                            ${dispatchSalesInvoiceData[0][
                                "totalDiscountedAmountLabel"
                                ]
                                }`}{" "}
                              Rs
                            </div> */}
                            <div
                              className={classes.summaryTitle}
                              style={{
                                fontSize: "12px",
                              }}
                            >
                              Total Discount:{" "}
                            </div>
                            <div
                              className={classes.summaryValue}
                              style={{
                                fontSize: "12px",
                                color: dispatchSalesInvoiceData[0]["totalDiscountedAmount"] && 
                                      dispatchSalesInvoiceData[0]["totalDiscountedAmount"] > 0 
                                      ? "red" 
                                      : "inherit"
                              }}
                            >
                              {dispatchSalesInvoiceData[0]["totalDiscountedAmount"] && 
                              dispatchSalesInvoiceData[0]["totalDiscountedAmount"] > 0
                                ? `- ${dispatchSalesInvoiceData[0]["totalDiscountedAmountLabel"]} Rs`
                                : "0 Rs"
                              }
                            </div>
                          </div>
                        </div>
                        <div className={classes.calDetailsContainer}>
                          <div>
                            <strong></strong>
                          </div>
                          <div>
                            <strong></strong>
                          </div>
                          <div className={classes.summaryContainer}>
                            <div
                              className={classes.summaryTitle}
                              style={{
                                fontSize: "12px",
                              }}
                            >
                              Delivery Charges:{" "}
                            </div>
                            <div
                              className={classes.summaryValue}
                              style={{
                                fontSize: "12px",
                              }}
                            >
                              {dispatchSalesInvoiceData[0]["deliveryCharges"]} Rs
                            </div>
                          </div>
                        </div>
                        <div className={classes.calDetailsContainer}>
                          <div>
                            <strong></strong>
                          </div>
                          <div>
                            <strong></strong>
                          </div>
                          <div className={classes.summaryContainer}>
                            <div
                              className={classes.summaryTitle}
                              style={{
                                fontSize: "12px",
                              }}
                            >
                              GST {dispatchSalesInvoiceData[0]["gstPercentage"]}:{" "}
                            </div>
                            <div
                              className={classes.summaryValue}
                              style={{
                                fontSize: "12px",
                              }}
                            >
                              {dispatchSalesInvoiceData[0]["gstAmount"]} Rs
                            </div>
                          </div>
                        </div>
                        {/* {dispatchSalesInvoiceData[0]["isReOrderWithoutAmount"] == 1 &&
                      <>
                        <div className={classes.calDetailsContainer}>
                          <div></div>
                          <div></div>
                          <div className={classes.summaryContainer}>
                            <div className={classes.summaryTitle}>Gross Total: </div>
                            <div className={classes.summaryValue}>
                              {
                                dispatchSalesInvoiceData[0][
                                "salesReturn"
                                ]
                              }{" "}
                              Rs
                            </div>
                          </div>
                        </div>
                        <div className={classes.calDetailsContainer}>
                          <div></div>
                          <div></div>
                          <div style={{ color: "red" }} className={classes.summaryContainerDisputed}>
                            <div className={classes.summaryTitle}>Disputed Order Ck - {dispatchSalesInvoiceData[0]["disputedOrderId"]} Discount:</div>
                            <div className={classes.summaryValue}>
                              {
                                dispatchSalesInvoiceData[0][
                                "salesReturn"
                                ]
                              }{" "}
                              Rs
                            </div>
                          </div>
                        </div>
                      </>
                    } */}
                        <div className={classes.calDetailsContainer}>
                          <div></div>
                          <div></div>
                          <div className={classes.summaryContainer}>
                            <div className={classes.summaryTitle}>Net Total: </div>
                            <div className={classes.summaryValue}>
                              {
                                dispatchSalesInvoiceData[0][
                                "totalDiscountedGrossAmountLabel"
                                ]
                              }{" "}
                              Rs
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    <div className={classes.footerContainer}>
                      <span style={{ marginRight: 20 }}>
                        Printed on {dateTime} by {userName}
                      </span>
                    </div>
                  </div> {/* Close contentContainer */}

                </div>

                <ReactToPrint
                  onAfterPrint={() => props.handlePrint()}
                  trigger={() => {
                    return (
                      <Button
                        id="btnWorkorderPrint"
                        style={{
                          float: "right",
                          marginTop: 40,
                          marginRight: 20,
                          textTransform: "capitalize",
                          opacity: 0.8,
                          marginLeft: "94%",
                        }}
                        color="primary"
                        variant="contained"
                      >
                        Print
                      </Button>
                    );
                  }}
                  content={() => componentRef.current}
                  pageStyle="@page { size: A5 portrait;}"
                />
              </div>
            ) : (
              <div></div>
            )}
          </Fragment>
        }
      />
      <CustomizedSnackbar
        isOpen={isOpenSnackbar}
        message={snackbarMessage}
        severity={snackbarSeverity}
        handleCloseSnackbar={() => handleSnackbar(false, "", "")}
        autoHideDuration={3000}
      />
    </Fragment>
  );
};

export default DispatchSalesInvoice;
